var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbiw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 36V32H16V25.8C14.3667 25.4333 12.9083 24.7417 11.625 23.725C10.3417 22.7083 9.4 21.4333 8.8 19.9C6.3 19.6 4.20833 18.5083 2.525 16.625C0.841667 14.7417 0 12.5333 0 10V8C0 6.9 0.391667 5.95833 1.175 5.175C1.95833 4.39167 2.9 4 4 4H8V0H28V4H32C33.1 4 34.0417 4.39167 34.825 5.175C35.6083 5.95833 36 6.9 36 8V10C36 12.5333 35.1583 14.7417 33.475 16.625C31.7917 18.5083 29.7 19.6 27.2 19.9C26.6 21.4333 25.6583 22.7083 24.375 23.725C23.0917 24.7417 21.6333 25.4333 20 25.8V32H28V36H8ZM8 15.6V8H4V10C4 11.2667 4.36667 12.4083 5.1 13.425C5.83333 14.4417 6.8 15.1667 8 15.6ZM18 22C19.6667 22 21.0833 21.4167 22.25 20.25C23.4167 19.0833 24 17.6667 24 16V4H12V16C12 17.6667 12.5833 19.0833 13.75 20.25C14.9167 21.4167 16.3333 22 18 22ZM28 15.6C29.2 15.1667 30.1667 14.4417 30.9 13.425C31.6333 12.4083 32 11.2667 32 10V8H28V15.6Z",
    fill: "#8CA4FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbiw);
export default __webpack_public_path__ + "static/media/BBIW.ddd49e0e56da736341fff2c235c9fda3.svg";
export { ForwardRef as ReactComponent };